import { render } from "./AIFeedback.vue?vue&type=template&id=8cb33016"
import script from "./AIFeedback.vue?vue&type=script&lang=js"
export * from "./AIFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__